<div class="user-esim-details-page">
  <!-- Back navigation header -->
  <div class="page-header">
    <button mat-button class="back-button" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      {{ 'ESIM.MY_ESIM' | translate }}
    </button>
    <h2>{{ 'ESIM.DETAILS.TITLE' | translate }}</h2>
  </div>

  <!-- Content -->
  <div class="esim-details-content">
    <div *ngIf="data">

      <!-- SECTION 1: STATUS HEADER -->
      <div class="status-header" *ngIf="esimStatus">
        <div>
          <h3 style="margin: 0;">{{ country }}</h3>
          <p style="margin: 4px 0 0 0; color: #666; font-size: 14px;">{{ operator }}</p>
        </div>
        <span class="status-chip" [ngClass]="getStatusChipClass()">
          {{ getStatusLabel() | translate }}
        </span>
      </div>

      <hr class="section-divider" *ngIf="esimStatus">

      <!-- SECTION 2: RECYCLED WARNING (RECYCLED only) -->
      <div class="warning-box warning-red" *ngIf="esimStatus === 'RECYCLED'">
        <mat-icon class="warning-icon">info</mat-icon>
        <div class="warning-content">
          <p class="warning-title">{{ 'ESIM.RECYCLED_INFO.TITLE' | translate }}</p>
          <p class="warning-message">{{ 'ESIM.RECYCLED_INFO.EXPLANATION' | translate }}</p>
        </div>
      </div>

      <!-- SECTION 4: DATA USAGE (ACTIVE/NOT_ACTIVE only) -->
      <div *ngIf="shouldShowUsageSection()" class="consumption-section">
        <h3 class="section-title">{{ 'ESIM.DETAILS.USAGE' | translate }}</h3>

        <div class="consumption-bars">
          <!-- Data consumption - Only if total > 0 -->
          <div class="consumption-item" *ngIf="shouldShowDataUsage()">
            <div class="item-header">
              <span class="item-label">{{ 'ESIM.DETAILS.DATA' | translate }}</span>
              <span class="item-value">
                {{ ((usageData.total - usageData.remaining) / 1024).toFixed(2) }} /
                {{ (usageData.total / 1024).toFixed(2) }} GB
              </span>
            </div>
            <div class="progress-bar">
              <div class="progress-fill"
                   [style.width.%]="calculateUsagePercentage(usageData.total, usageData.remaining)">
              </div>
            </div>
          </div>

          <!-- Voice consumption - Only if total_voice > 0 -->
          <div class="consumption-item" *ngIf="shouldShowVoiceUsage()">
            <div class="item-header">
              <span class="item-label">{{ 'ESIM.DETAILS.VOICE' | translate }}</span>
              <span class="item-value">
                {{ usageData.total_voice - usageData.remaining_voice }} /
                {{ usageData.total_voice }} {{ 'ESIM.DETAILS.MINUTES' | translate }}
              </span>
            </div>
            <div class="progress-bar">
              <div class="progress-fill"
                   [style.width.%]="calculateUsagePercentage(usageData.total_voice, usageData.remaining_voice)">
              </div>
            </div>
          </div>

          <!-- Text consumption - Only if total_text > 0 -->
          <div class="consumption-item" *ngIf="shouldShowTextUsage()">
            <div class="item-header">
              <span class="item-label">{{ 'ESIM.DETAILS.MESSAGES' | translate }}</span>
              <span class="item-value">
                {{ usageData.total_text - usageData.remaining_text }} /
                {{ usageData.total_text }} SMS
              </span>
            </div>
            <div class="progress-bar">
              <div class="progress-fill"
                   [style.width.%]="calculateUsagePercentage(usageData.total_text, usageData.remaining_text)">
              </div>
            </div>
          </div>
        </div>

        <hr class="section-divider">
      </div>

      <!-- SECTION 5: QR & INSTALLATION (NOT_ACTIVE only) -->
      <div *ngIf="esimStatus === 'NOT_ACTIVE'" class="qr-installation-section">
        <h3 class="section-title">{{ 'ESIM.QR_INSTALLATION.TITLE' | translate }}</h3>

        <!-- 90-DAY ACTIVATION WARNING -->
        <div class="warning-box warning-orange" *ngIf="getDaysUntilRecycling() !== null">
          <mat-icon class="warning-icon">warning</mat-icon>
          <div class="warning-content" *ngIf="getDaysUntilRecycling()! > 0">
            <p class="warning-title">{{ 'ESIM.ACTIVATION_DEADLINE.TITLE' | translate }}</p>
            <p class="warning-message">
              {{ 'ESIM.ACTIVATION_DEADLINE.MESSAGE' | translate: {
                days: getDaysUntilRecycling(),
                date: getRecyclingDeadlineDate()
              } }}
            </p>
            <p class="warning-tip">{{ 'ESIM.ACTIVATION_DEADLINE.TIP' | translate }}</p>
          </div>
          <div class="warning-content" *ngIf="getDaysUntilRecycling()! <= 0">
            <p class="warning-title">{{ 'ESIM.ACTIVATION_DEADLINE.TITLE_OVERDUE' | translate }}</p>
            <p class="warning-message">
              {{ 'ESIM.ACTIVATION_DEADLINE.MESSAGE_OVERDUE' | translate: {
                date: getRecyclingDeadlineDate()
              } }}
            </p>
            <p class="warning-tip">{{ 'ESIM.ACTIVATION_DEADLINE.TIP_OVERDUE' | translate }}</p>
          </div>
        </div>

        <p class="section-subtitle">{{ 'ESIM.QR_INSTALLATION.SUBTITLE' | translate }}</p>

        <!-- QR Code -->
        <div class="qr-code-container" *ngIf="qrCodeUrl">
          <h4>{{ 'ESIM.QR_INSTALLATION.QR_CODE' | translate }}</h4>
          <img [src]="qrCodeUrl" alt="QR Code" class="qr-code-image" />
        </div>

        <div class="no-qr-warning" *ngIf="!qrCodeUrl">
          {{ 'ESIM.QR_INSTALLATION.NO_QR' | translate }}
        </div>

        <!-- Activation Codes -->
        <div class="activation-codes" *ngIf="activationUrl || activationCode">
          <h4>{{ 'ESIM.QR_INSTALLATION.ACTIVATION_CODES' | translate }}</h4>

          <!-- Activation URL -->
          <div *ngIf="activationUrl">
            <label class="code-label">{{ 'ESIM.QR_INSTALLATION.ACTIVATION_URL' | translate }}</label>
            <div class="code-container">
              <div class="code-input">{{ activationUrl }}</div>
              <button
                class="copy-button"
                [ngClass]="{'copied': urlCopied}"
                (click)="copyToClipboard(activationUrl, 'url')">
                {{ (urlCopied ? 'ESIM.QR_INSTALLATION.COPIED' : 'ESIM.QR_INSTALLATION.COPY') | translate }}
              </button>
            </div>
          </div>

          <!-- Activation Code -->
          <div *ngIf="activationCode">
            <label class="code-label">{{ 'ESIM.QR_INSTALLATION.ACTIVATION_CODE' | translate }}</label>
            <div class="code-container">
              <div class="code-input">{{ activationCode }}</div>
              <button
                class="copy-button"
                [ngClass]="{'copied': codeCopied}"
                (click)="copyToClipboard(activationCode, 'code')">
                {{ (codeCopied ? 'ESIM.QR_INSTALLATION.COPIED' : 'ESIM.QR_INSTALLATION.COPY') | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- Installation Instructions (Expandable) -->
        <mat-expansion-panel class="installation-guide-panel" *ngIf="installationGuide">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 8px;">description</mat-icon>
              {{ 'ESIM.QR_INSTALLATION.INSTRUCTIONS_TITLE' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="installation-instructions">
            <!-- Device Tabs -->
            <div class="device-tabs">
              <button
                class="device-tab"
                [class.active]="selectedDevice === 'ios'"
                (click)="selectDevice('ios')"
                *ngIf="installationGuide.ios?.length">
                {{ 'ESIM.QR_INSTALLATION.IOS' | translate }}
              </button>
              <button
                class="device-tab"
                [class.active]="selectedDevice === 'android'"
                (click)="selectDevice('android')"
                *ngIf="installationGuide.android?.length">
                {{ 'ESIM.QR_INSTALLATION.ANDROID' | translate }}
              </button>
            </div>

            <!-- iOS Instructions -->
            <div class="instructions-content" *ngIf="selectedDevice === 'ios' && installationGuide.ios?.length">
              <!-- QR Code Installation -->
              <div class="instruction-step">
                <h5>{{ 'ESIM.QR_INSTALLATION.QR_STEPS' | translate }}</h5>
                <ol>
                  <li *ngFor="let step of installationGuide.ios?.[0]?.installation_via_qr_code?.steps | keyvalue">
                    {{ step.value }}
                  </li>
                </ol>
              </div>

              <!-- Manual Installation -->
              <div class="instruction-step">
                <h5>{{ 'ESIM.QR_INSTALLATION.MANUAL_STEPS' | translate }}</h5>
                <ol>
                  <li *ngFor="let step of installationGuide.ios?.[0]?.installation_manual?.steps | keyvalue">
                    {{ step.value }}
                  </li>
                </ol>
              </div>

              <!-- Network Setup -->
              <div class="instruction-step">
                <h5>{{ 'ESIM.QR_INSTALLATION.NETWORK_STEPS' | translate }}</h5>
                <ol>
                  <li *ngFor="let step of installationGuide.ios?.[0]?.network_setup?.steps | keyvalue">
                    {{ step.value }}
                  </li>
                </ol>
              </div>
            </div>

            <!-- Android Instructions -->
            <div class="instructions-content" *ngIf="selectedDevice === 'android' && installationGuide.android?.length">
              <!-- QR Code Installation -->
              <div class="instruction-step">
                <h5>{{ 'ESIM.QR_INSTALLATION.QR_STEPS' | translate }}</h5>
                <ol>
                  <li *ngFor="let step of installationGuide.android?.[0]?.installation_via_qr_code?.steps | keyvalue">
                    {{ step.value }}
                  </li>
                </ol>
              </div>

              <!-- Manual Installation -->
              <div class="instruction-step">
                <h5>{{ 'ESIM.QR_INSTALLATION.MANUAL_STEPS' | translate }}</h5>
                <ol>
                  <li *ngFor="let step of installationGuide.android?.[0]?.installation_manual?.steps | keyvalue">
                    {{ step.value }}
                  </li>
                </ol>
              </div>

              <!-- Network Setup -->
              <div class="instruction-step">
                <h5>{{ 'ESIM.QR_INSTALLATION.NETWORK_STEPS' | translate }}</h5>
                <ol>
                  <li *ngFor="let step of installationGuide.android?.[0]?.network_setup?.steps | keyvalue">
                    {{ step.value }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="loading-container">
          <mat-progress-spinner mode="indeterminate" color="primary" diameter="40"></mat-progress-spinner>
          <p style="margin-left: 12px;">{{ 'ESIM.QR_INSTALLATION.LOADING' | translate }}</p>
        </div>

        <hr class="section-divider">
      </div>

      <!-- SECTION 6: EXTRA INFORMATION (all statuses) -->
      <div class="extra-info-section">
        <h3 class="section-title">{{ 'ESIM.EXTRA_INFO.TITLE' | translate }}</h3>

        <div class="info-grid">
          <!-- ICCID -->
          <div class="info-row" *ngIf="details?.iccid">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.ICCID' | translate }}</div>
            <div class="info-value">{{ details.iccid }}</div>
          </div>

          <!-- MSISDN -->
          <div class="info-row" *ngIf="details?.msisdn">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.MSISDN' | translate }}</div>
            <div class="info-value">{{ details.msisdn }}</div>
          </div>

          <!-- Country -->
          <div class="info-row" *ngIf="country">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.COUNTRY' | translate }}</div>
            <div class="info-value">{{ country }}</div>
          </div>

          <!-- Operator -->
          <div class="info-row" *ngIf="operator">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.OPERATOR' | translate }}</div>
            <div class="info-value">{{ operator }}</div>
          </div>

          <!-- Purchase Date -->
          <div class="info-row" *ngIf="createdAt">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.PURCHASE_DATE' | translate }}</div>
            <div class="info-value">{{ formatDate(createdAt) }}</div>
          </div>

          <!-- Activation Date - Only for ACTIVE, FINISHED, EXPIRED -->
          <div class="info-row" *ngIf="shouldShowActivationDate()">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.ACTIVATION_DATE' | translate }}</div>
            <div class="info-value">{{ formatDate(activatedAt) }}</div>
          </div>

          <!-- Expiration Date (for ACTIVE) -->
          <div class="info-row" *ngIf="esimStatus === 'ACTIVE' && getExpirationDate()">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.EXPIRATION_DATE' | translate }}</div>
            <div class="info-value">{{ getExpirationDate() }}</div>
          </div>

          <!-- Recycling Deadline - Only for NOT_ACTIVE -->
          <div class="info-row" *ngIf="shouldShowRecyclingDeadline()">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.RECYCLING_DEADLINE' | translate }}</div>
            <div class="info-value">{{ getDaysUntilRecycling() }} {{ 'ESIM.EXTRA_INFO.DAYS' | translate }}</div>
          </div>

          <!-- Expired Date - Only for EXPIRED -->
          <div class="info-row" *ngIf="shouldShowExpiredDate()">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.EXPIRED_DATE' | translate }}</div>
            <div class="info-value">{{ formatDate(expiredAt) }}</div>
          </div>

          <!-- Finished Date - Only for FINISHED -->
          <div class="info-row" *ngIf="shouldShowFinishedDate()">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.FINISHED_DATE' | translate }}</div>
            <div class="info-value">{{ formatDate(finishedAt) }}</div>
          </div>

          <!-- Recycled Date - Only for RECYCLED -->
          <div class="info-row" *ngIf="shouldShowRecycledDate()">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.RECYCLED_DATE' | translate }}</div>
            <div class="info-value">{{ formatDate(recycledAt) }}</div>
          </div>

          <!-- Data Amount -->
          <div class="info-row" *ngIf="packageDetails?.data">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.DATA_AMOUNT' | translate }}</div>
            <div class="info-value" [ngClass]="{'unlimited': packageDetails.is_unlimited}">
              {{ packageDetails.is_unlimited ? ('ESIM.EXTRA_INFO.IS_UNLIMITED' | translate) : (packageDetails.data + ' GB') }}
            </div>
          </div>

          <!-- Validity -->
          <div class="info-row" *ngIf="packageDetails?.day">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.VALIDITY' | translate }}</div>
            <div class="info-value">{{ packageDetails.day }} {{ packageDetails.day == 1 ? ('ESIM.DAY' | translate) : ('ESIM.DAYS' | translate) }}</div>
          </div>

          <!-- Price -->
          <div class="info-row" *ngIf="packageDetails?.price">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.PRICE' | translate }}</div>
            <div class="info-value">{{ packageDetails.price }} €</div>
          </div>

          <!-- Type -->
          <div class="info-row" *ngIf="packageDetails?.type">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.TYPE' | translate }}</div>
            <div class="info-value">{{ packageDetails.type }}</div>
          </div>

          <!-- Plan Type -->
          <div class="info-row" *ngIf="packageDetails?.plan_type">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.PLAN_TYPE' | translate }}</div>
            <div class="info-value">{{ packageDetails.plan_type }}</div>
          </div>

          <!-- User Reference -->
          <div class="info-row" *ngIf="userReference">
            <div class="info-label">{{ 'ESIM.EXTRA_INFO.USER_REFERENCE' | translate }}</div>
            <div class="info-value">{{ userReference }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
